import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../store";
import { setPatient, removeAIReview, touchPatientUpdatedAt } from "../store/actions";
import { deleteAIReview } from "../api/aiReviewService";
import { ToastManager } from "../components/organisms/CommonUI/ToastPopup/ToastManager";
import { log, LogLevel } from "../utils/LogUtil";

export const useAIReviewDelete = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { patients } = useSelector((state: RootState) => state.data);
  const [isLoading, setIsLoading] = useState(false);

  const deleteReview = async (reviewId: number, patientId: number) => {
    setIsLoading(true);
    try {
      log(LogLevel.INFO, "useAIReviewDelete:deleteReview:Starting delete", {
        reviewId,
        patientId,
      });

      // 1. API 호출로 삭제
      const result = await deleteAIReview(reviewId);
      
      if (result.error === 0) {
        // 2. store patients의 해당 환자 aiReviews에서 제거
        const patient = patients[patientId];
        if (patient?.aiReviews) {
          const updatedAiReviews = patient.aiReviews.filter(
            (review) => review.id !== reviewId
          );
          
          dispatch(
            setPatient({
              ...patient,
              aiReviews: updatedAiReviews,
            })
          );
          dispatch(touchPatientUpdatedAt(patientId));
        }

        // 3. store reviews에서 해당 리포트 삭제
        dispatch(removeAIReview(reviewId));

        // 성공 메시지
        ToastManager.show({
          content: "보고서가 삭제되었습니다.",
          duration: 2000,
        });

        log(LogLevel.INFO, "useAIReviewDelete:deleteReview:Delete successful", {
          reviewId,
          patientId,
        });

        // 4. 환자 상세 페이지로 이동
        navigate(`/patients/${patientId}`);
        
        return true;
      } else {
        throw new Error(result.message || "보고서 삭제에 실패했습니다.");
      }
    } catch (error) {
      log(LogLevel.ERROR, "useAIReviewDelete:deleteReview:Failed to delete", error);
      ToastManager.show({
        content: "보고서 삭제에 실패했습니다.",
        duration: 2000,
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { deleteReview, isLoading };
};